export interface ViewportSizeParameters {
    top: number;
    left: number;
    bottom: number;
    right: number;
}
export const LOAD_MORE_ACTIVATION_HEIGHT = 150;

/**
 * Generate a default viewport size object
 */
export const getDefaultViewportSizeParameters = (): ViewportSizeParameters => ({
    top: 0,
    left: 0,
    bottom: window.innerHeight || document.documentElement.clientHeight,
    right: window.innerWidth || document.documentElement.clientWidth,
});

/**
 * Is element in viewport base on getBoundingClientRect method
 *
 * @link https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
 */
export const isElementInViewport = (
    element: HTMLElement,
    sizeParameters: ViewportSizeParameters = getDefaultViewportSizeParameters(),
): boolean => {
    const rect: DOMRect = element.getBoundingClientRect();

    return (
        rect.top >= sizeParameters.top &&
        rect.left >= sizeParameters.left &&
        rect.bottom <= sizeParameters.bottom &&
        rect.right <= sizeParameters.right
    );
};

export const isLoadMoreInViewport = (element: HTMLElement): boolean => {
    // calc the % of inner height before element based on the constants activation height
    const calc =
        (window.innerHeight || document.documentElement.clientHeight) *
        (LOAD_MORE_ACTIVATION_HEIGHT / 100);
    // build params
    const params: ViewportSizeParameters = getDefaultViewportSizeParameters();
    // update bottom
    params.bottom = calc + params.bottom;

    return isElementInViewport(element, params);
};
